import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchLeftStudents = createAsyncThunk(
  "leftStudents/fetchLeftStudents",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${server}/all_data_of_leftstudents_mongodb`,
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        }
      );
      const data = response.data?.["body-json"]?.body?.data;
      if (data) {
        return data;
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching left students:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const leftStudentsSlice = createSlice({
  name: "leftStudents",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeftStudents.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchLeftStudents.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchLeftStudents.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default leftStudentsSlice.reducer;
